<template>
    <div>
        <div style="overflow:scroll;height:100%;" v-if="isShow">
            <div class="contactList-header">
                <el-button @click="$emit('returnDetail')" size="mini" style="margin-bottom:10px">返回</el-button>
                <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 20px">
                    <el-breadcrumb-item><b class="linkTo" @click="$emit('returnClientList')" >客户列表</b></el-breadcrumb-item>
                    <el-breadcrumb-item><b class="linkTo" @click="$emit('returnDetail')" >客户详情</b></el-breadcrumb-item>
                    <el-breadcrumb-item>联系人列表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="Contact-header">
                <div style="display:flex; align-items: center;">
                    <el-button @click="addContact">新增联系人</el-button>
                </div>
                <CustomTool style="width:120px;" :column_mapper="column_mapper" :show-time-area="false" :show-time="false" :show-refresh="false" :show-filter="true" :show-export="true" :filterArchiveData="filterArchiveData" @filters="filterContentChange" @export="exportExcel"/>
            </div>
            <div style="width: calc(100% - 0px)">
                <div style="height: 700px;width:100%;box-sizing: border-box;padding:20px 0px;overflow: scroll;background:white;">
                    <custom-table
                        ref="mytable"
                        table-id="contact-table"
                        :project-list-dl="tableData.projectList"
                        :show-coloums-dl="tableData.showColoums"
                        :column_mapper="tableData.column_mapper"
                        @current-change="currentChange"
                        @row-click="rowClick"
                        :sort-column-name-dl="tableData.sortColumnName"
                        :sort-column-order-dl="tableData.sortColumnOrder"

                        :totalnums-dl="tableData.totalnums"
                        :pagesize-dl="tableData.pagesize"
                        :page-number-dl="tableData.pageNumber"

                        :fixed-columns="tableData.fixedList"
                        :fixed-right-columns="tableData.fixedRightList"

                        :disableDrag="true"
                        :sortable="false"
                        :sortableColumns="tableData.sortableColumns"

                        :pagination="tableData.pagination"

                        :is-loading-dl="tableData.detailLoading"
                        :use-virtual="false"
                        :row-hegit="0"

                        :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
                        
                        :padding="'0px'"
                        :custom-column-width="tableData.customColumnWidth"
                    />
                </div>
            </div>
            
            <ContactDialog v-model="contactDialogVisible" :clientId="clientId" @refresh="refresh"/>
        </div>
        <ContactDetail fromPage="ContactList" @returnClientList="$emit('returnClientList')" @returnClientDetail="$emit('returnDetail')" @returnList="isShow=true" :clientName="clientName" :clientId="contactDetailInfo.client_id" :contactId="contactDetailInfo.contact_id" :contactName="contactDetailInfo.name" @refresh="refresh" v-else />
    </div>
</template>

<script>
import customTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import ContactDialog from "@/component/Client/Contact/ContactDialog";
import ContactDetail from "@/component/Client/Contact/ContactDetail/ContactDetail"
import {getContactList, exportContact} from '@/api/api';
export default {
    name: "MainTable",
    components: {
        customTable,
        CustomTool,
        ContactDialog,
        ContactDetail
    },
    props: {
        clientId: {
            required: true
        },
        clientName: {
            required: true
        },
        refreshId: {
            required: true
        }
    },
    data() {
        return {
            isShow: true,
            contactDialogVisible: false,
            // 表格所需数据
            tableData: {
                detailLoading: false,
                projectList: [], //表格列表所有数据
                showProjectList:[],//显示的数据
                column_mapper: {},//表头所有列的枚举
                showColoums: [],//当前显示的表头列
                sortColumnName: "",//需要排序的列名
                sortColumnOrder: "",//排序的命令
                totalnums: 10,//所有的数据条数
                pageNumber: 1,//当前页
                fixedList: [],
                pagesize: 10,//一页数据的行数（公用
                pagination:true
            },
            filterRequestData:{},
            // 过滤器属性
            filterContent:{
                queryCond: [],
                sortCond: {
                    columnName: "",
                    value: ""
                },
            },
            column_mapper: {
                "cellphone": "手机:varchar",
                "dept": "部门:varchar",
                "email": "邮箱:varchar",
                "gender": "性别:varchar",
                "level": "职级:varchar",
                "name": "名称:varchar",
                "position": "岗位:varchar",
                "telephone": "固话:varchar",
            }
        }
    },

    mounted() {
        this.refresh()
    },

    watch: {
        refreshId(newVal) {
            this.refresh()
        }
    },

    methods: {

        rowClick(e) {
            this.contactDetailInfo = e
            this.isShow = false
        },

        currentChange(e) {
            this.tableData.pageNumber = e;
            this.refresh(false)
        },

        async getData(resetPage=false) {
            if(resetPage){
                this.tableData.pageNumber = 1
            }
            this.filterRequestData = {
                pagiInfo: {
                    currentPage: this.tableData.pageNumber,
                    pagesize: this.tableData.pagesize
                },
                client_id: this.clientId,
                ...this.filterContent
            }
            let postData = this.filterRequestData
            let res = await getContactList(postData)
            let resData = res
            console.log("resDate", resData)
            const {respData: {cols_mapper, data , columns_list,totalnums}} = resData
            // console.log('返回结果', resData,cols_mapper,data,columns_list)
            this.tableData.column_mapper = cols_mapper
            this.tableData.projectList = data
            this.tableData.totalnums =  totalnums
            this.tableData.showColoums = columns_list
            // console.log('this.tableData.showColoums',this.tableData.showColoums )
            this.$nextTick(() => {
                this.tableData.detailLoading = false
            })
        },

        async refresh(refresh=false){
            this.tableData.detailLoading = true
            await this.getData(false)
            if (refresh) {
                this.$emit('refresh')
            }
        },

        filterContentChange(content) {
            console.log('filterContentChange',content)
            Object.assign(this.filterContent,content)
            this.refresh()
        },

        async exportExcel() {
            let param = this.filterRequestData
            let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
            try {
                let {data} = await exportContact(param)
                loadingInstance.close();
                const blob = new Blob([data])
                var date = new Date()
                let Y = date.getFullYear().toString()
                let M = (date.getMonth() + 1).toString().padStart(2, "0")
                let D = date.getDate().toString().padStart(2, "0")
                let H = date.getHours().toString().padStart(2, "0")
                let m = date.getMinutes().toString().padStart(2, "0")
                let s = date.getSeconds().toString().padStart(2, "0")
                let fileName = '联系人列表-' + Y + M + D + H + m + s + ".xlsx"

                const link = document.createElement('a')
                link.download = fileName
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                document.body.appendChild(link)
                link.click()
                URL.revokeObjectURL(link.href)
                document.body.removeChild(link)

            } catch(err) {
                loadingInstance.close();
                var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
                if (issafariBrowser) {
                this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
                } else {
                this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
                }
            }
        },

        addContact() {
            this.contactDialogVisible=true
        }
    }
}


</script>

<style scoped>
    .Contact-header{
        width:calc(100%);
        display: flex;
        justify-content: space-between;
    }
    .contactList-header{
        display: flex;
        align-items: center;
    }
    .linkTo{
        cursor: pointer;
    }
    .linkTo:hover{
        color:#1473E3;
    }
</style>

